import { Injectable } from '@angular/core';
import { Log } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class HostnameService {
  private static readonly workforceHostnames = ['app.workforce.ai', 'workforce.ai', '127.0.0.1'];

  // The active experience (which route table / shell is mounted). Workforce is
  // the default everywhere; the GotLiveData experience is deprecated and only
  // reachable via the Alt+Shift+W debug hotkey. Route-choosing code must check
  // this rather than the hostname, which is now only used for branding.
  private static appExperience: 'workforce' | 'gotlivedata' = 'workforce';

  constructor() {}

  static setAppExperience(experience: 'workforce' | 'gotlivedata') {
    this.appExperience = experience;
  }

  static isWorkforceExperience(): boolean {
    return this.appExperience === 'workforce';
  }

  static isWorkforceHostname(): boolean {
    const hostname = window.location.hostname;
    Log.d('Checking if hostname is workforce', hostname);

    // TEMP FOR DEVE ONLY!
    if (hostname.includes('workforce')) {
      return true;
    }

    return this.workforceHostnames.includes(hostname);
  }
}
